{
  "name": "m0-boot",
  "seed": 1,
  "track": null,
  "fixedDtMs": 16.666666666666668,
  "cars": [
    { "id": "player", "spawn": { "x": 640, "y": 360, "angle": -1.5707963267948966 }, "ai": null }
  ],
  "inputs": [],
  "captures": [{ "frame": 1, "name": "boot" }]
}
